import React from 'react';
import { FormControl, Select, MenuItem } from '@mui/material';
import PropTypes from 'prop-types';

function PeriodSelector({
  period,
  onChange
}) {
  const handleChange = (event) => {
    onChange({ period: event.target.value });
  };

  return (
    <div className="border" style={{ display: 'flex', alignItems: 'center' }}>
      <FormControl
        variant="standard"
        sx={{
          margin: 0,
          marginLeft: 0,
          minWidth: 120,
          maxWidth: 300,
        }}
      >
        <Select
          value={period}
          name="period"
          onChange={handleChange}
          sx={{
            '& .MuiInputBase-input': {
              padding: 0,
              paddingRight: 24,
              fontWeight: 'bold',
              fontFamily: 'Verdana !important',
              fontSize: '10pt',
            },
          }}
        >
          <MenuItem value="month">By Month for</MenuItem>
          <MenuItem value="year">By Year for</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
}

PeriodSelector.propTypes = {
  period: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default PeriodSelector;
